<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
import { frontChannelOneLevelArticleType, getFrontChannelArticleTypeSubApi } from '@/api'
import { mapActions } from 'vuex'
export default {
  name: 'App',
  methods: {
    ...mapActions(['changeLanguage', 'loadTypeLists', 'changeType', 'changeSubType']),
  },
  async mounted () {
    const res = await frontChannelOneLevelArticleType();
        if (res.data && res.data.length) {
            for (const item of res.data) {
              const r = await getFrontChannelArticleTypeSubApi({ typeId: item.typeId });
              item.subMap = r.data;
            }
            this.loadTypeLists(res.data);
          }
  },
}
</script>

<style>
body{
  margin:0px;
  padding:0px
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:100%;
  width: 100%;
  margin:0px;
  padding:0px;

}
</style>



// WEBPACK FOOTER //
// src/App.vue